import MathsHomeView from "@/views/MathsHomeView.vue";
import { RouteRecordRaw } from "vue-router";

const mathRoutes: RouteRecordRaw[] = [
  {
    path: "/maths",
    name: "MathsHome",
    component: MathsHomeView,
  },
  {
    path: "/maths/level/:levelId",
    name: "MathLevel",
    component: () => import("../views/maths/MathLevelView.vue"),
  },
  {
    path: "/maths/test/:customLevelId?",
    name: "MahtTest",
    component: () => import("../views/maths/MathTestView.vue"),
  },
];

export default mathRoutes;
